@let isWrappedFunction = functionWrapped();
<div class="function" [formGroup]="form">
  <div class="function-parameters">
    <div class="header">
      <div class="form-control">
        <label class="required">Function Name</label>
        <input
          #functionNameInput
          type="text"
          formControlName="name"
          name="name"
          class="bd-text-input tall w-full"
          required
        />
      </div>
      <div class="actions">
        <button blazeIconButton blazeIconButtonSize="lg" (click)="removeFunction.emit()">
          <mat-icon svgIcon="icon_trash_16" />
        </button>
        <button
          blazeIconButton
          blazeIconButtonSize="lg"
          [blazeIconButtonActive]="!isWrappedFunction"
          (click)="functionWrapped.set(!isWrappedFunction)"
        >
          <mat-icon [class.rotate-180]="isWrappedFunction" svgIcon="icon_chevron_up_16" />
        </button>
      </div>
    </div>
    @if (!isWrappedFunction) {
      <div class="form-control">
        <label>Model</label>
        <input
          type="text"
          formControlName="modelName"
          placeholder="gpt-4o"
          name="modelName"
          class="bd-text-input tall w-full"
        />
      </div>
      <div class="form-control">
        <label>System Instruction</label>
        <textarea
          formControlName="systemInstruction"
          name="systemInstruction"
          class="bd-text-input w-full"
          placeholder="Tell the AI what to do: “Draft a friendly confirmation email.”"
          rows="4"
        ></textarea>
      </div>
      <div class="form-control flex">
        <mat-slide-toggle
          (change)="showAdvanced = !showAdvanced"
          [checked]="showAdvanced"
          class="bd-toggle w-[140px] !h-40"
          disableRipple
          labelPosition="after"
        >
          Advanced
        </mat-slide-toggle>
        @if (showAdvanced) {
          <div class="form-control">
            <label class="advanced-label">Temperature</label>
            <input
              type="text"
              formControlName="temperature"
              name="temperature"
              class="bd-text-input w-full"
              placeholder="1.0"
              blazeInputMask
              predefinedMask="numberInputMask"
              [maskOptions]="temperatureMaskOptions"
            />
          </div>
          <div class="form-control">
            <label class="advanced-label right">Top_p</label>
            <input
              type="text"
              formControlName="top_p"
              name="top_p"
              class="bd-text-input w-full"
              placeholder="1.0"
              blazeInputMask
              predefinedMask="numberInputMask"
              [maskOptions]="topMaskOptions"
            />
          </div>
          <mat-icon
            class="info-icon"
            svgIcon="icon_info_16"
            [blazeTooltip]="'Temperature: 0 to 2.0\nTop_p: 0 to 1.0'"
            matTooltipClass="whitespace-pre-line [text-align-last:left]"
            matTooltipPosition="right"
          />
        }
      </div>
    }
  </div>
  @if (!isWrappedFunction) {
    <blaze-openai-connector-output-parameters
      view="list"
      [properties]="outputParameters"
      sectionTitle="Outgoing Data"
      (valuesChanged)="updateParameters($event)"
      (isValid)="isChildValid.set($event)"
    />
  }
</div>
